import React, {useState} from "react"
import {sendToServer} from "../BidibDataProvider";
import {MdOutlineSettingsEthernet} from "react-icons/md";
import {FaUsb} from "react-icons/fa";

//import { FiSend } from "react-icons/fi";
import {PiPlugs, PiPlugsConnected} from "react-icons/pi";

import {FaPlus, FaMinus} from "react-icons/fa6";
import IconButton from "./IconButton.tsx";

const SERIAL = "serial"
const TCP = "tcp"

const NewConnection = () => {

    const [conm, setConm] = useState(TCP)

    const [addr, setAddr] = useState("192.168.11.120");
    const [port, setPort] = useState(62875);
    const [devi, setDevi] = useState("/dev/ttyUSB0");

    const [active, setActive] = useState(true);

    const icon = conm === SERIAL ? <FaUsb size={16}/> : <MdOutlineSettingsEthernet size={16}/>


    function connectClick() {

        //setActive(false);

        let cx = {
            uid: "_tmp_",
            cmd: 'newconnection',
            contype: conm,
        }

        if (conm === SERIAL) {
            cx.device = devi
        } else if (conm === TCP) {
            cx.port = port
            cx.addr = addr
        }

        console.log(cx)
        sendToServer(cx)
    }

    // onChange={(e) => { setConM(e.target.value) }}

    return (

        active ?
            <div style={{
                display: "flex",
                padding: '10px',
                margin: '10px',
                border: '1px solid black',
                borderRadius: '5px',
                background: 'rgb(168,165,159)',
                color: 'rgb(27,35,54)'
            }}>

                <div style={{
                    float: "left",
                    width: "90%",
                    verticalAlign: 'baseline',
                    alignItems: 'center',
                }}>

                    <span style={{
                        color: 'black',
                        marginRight: 10,
                    }}>
                        {icon}
                    </span>

                    <select style={{
                        background: 'rgb(195,195,195)',
                        border: '1px solid black',
                        userSelect: 'none',
                        outline: 'none',
                    }} defaultValue={conm} onChange={(e) => {
                        setConm(e.target.value)
                    }}>
                        <option key={'serial'} value={"serial"}>Serial</option>
                        <option key={'tcp'} value={"tcp"}>TCP</option>
                    </select>




                    <div style={{
                        marginTop: "10px",
                        display: "flex",
                        width: "135px",
                    }}>

                        {
                            conm === SERIAL ?
                                <input
                                    style={{
                                        width: "100%",
                                        background: 'rgb(195,195,195)',
                                        border: '1px solid black',
                                        fontSize: "11px",
                                        outline: 'none',
                                    }}
                                    value={devi}
                                    onChange={(e) => setDevi(e.target.value)}></input>
                                :
                                <div style={{display: "flex"}}>
                                    <input
                                        style={{
                                            width: "70%",
                                            background: 'rgb(195,195,195)',
                                            border: '1px solid black',
                                            marginRight: "5px",
                                            fontSize: "11px",
                                            outline: 'none',
                                        }}
                                        value={addr}
                                        onChange={(e) => setAddr(e.target.value)}></input>
                                    <input
                                        style={{
                                            width: "25%",
                                            background: 'rgb(195,195,195)',
                                            border: '1px solid black',
                                            fontSize: "11px",
                                            outline: 'none',
                                        }}
                                        value={port}
                                        onChange={(e) => setPort(e.target.value)}
                                    ></input>
                                </div>
                        }


                    </div>

                </div>

                <div style={{
                    float: "right",
                    width: "10%",
                }}>
                    <IconButton iconOn={<PiPlugsConnected />} iconOff={<PiPlugs />} on={false} callback={connectClick} title={'connect'}/>
                </div>
            </div>
            :
            <div style={{
                display: "flex",
                paddingRight: '10px',
                marginTop: '8px',
                //marginRight: '10px',
                //border: '1px solid black',
                //borderRadius: '5px',
                //background: 'rgb(168,165,159)',
                color: 'rgb(27,35,54)'
            }}>
                <div style={{
                    float: "left",
                    width: "90%",
                }}>
                    </div>
                    <div style={{
                        width: "10%",
                        float: "right",
                    }}>

                        <div className="iconButton"
                             //onClick={() => setActive(true)}
                        >
                            {active ? <FaMinus/> : <FaPlus/>}
                        </div>

                    </div>
                </div>
                )
                }

                export default NewConnection
